module.exports = __webpack_public_path__ + "static/media/spot_logo.6b153c0a.svg";